import { TdsTextField } from '@scania/tegel-react';

const TextField = () => {
  return (
    <>
      <div className="tds-headline-02 tds-u-pb1">Text field</div>
      <TdsTextField size="md" placeholder="Placeholder"></TdsTextField>
    </>
  );
};

export default TextField;
